import { render } from "./allMembers.vue?vue&type=template&id=6e54f241"
import script from "./allMembers.vue?vue&type=script&lang=js"
export * from "./allMembers.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/gafwa_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__